
<template lang="pug">
    v-layout(align-start='')
        v-flex
            div.elevation-4.hed
              div.titulo
                span Cuentas
              div.raya
              div.busqueda
                div(style='width:45%;height: 100%;')
                  //- v-text-field(v-model='search' label='Búsqueda' single-line hide-details)
              div.nuevo
                v-dialog(v-model='dialog', persistent='', max-width='40%')
                    template(v-slot:activator='{ on }')
                        v-btn.mx-2(v-if='validarCrear()', fab='', dark='', small='', color='success', v-on='on')
                            v-icon(dark='') mdi-plus
                    v-card(color='grey_1')
                        v-app-bar(dark color='primary')
                            span.headline {{ formTitle }}
                        v-card-text
                            v-row(dense)
                                v-col(cols='12')
                                   v-card(color='white')
                                      v-card-text
                                         v-row(dense)
                                            v-col(cols='12', sm='12', md='12')
                                               v-text-field#nombreCuenta(
                                                dense,
                                                outlined,
                                                v-model='editedItem.nombre',
                                                label='Nombre',
                                                v-uppercase)
                                         v-row(dense)
                                            v-col(cols='12', sm='12', md='12')
                                                v-text-field#codigoCuentas(
                                                  dense, 
                                                  outlined,
                                                  v-model='editedItem.codigocli',
                                                  label='Codigo',
                                                  v-uppercase)
                                            //- v-col(cols='12', sm='12', md='12')
                                            //-     v-text-field(dense='', outlined='', v-model='editedItem.descripcion', label='Descripcion')
                        v-card-actions
                            v-spacer
                            v-btn(color='error', small='', dark='', @click='close')
                                v-icon mdi-close
                                | Cancelar
                            v-btn(color='success', small='', dark='', @click='save')
                                v-icon mdi-content-save
                                | Guardar
            div.tabla
                div.header
                    div.titulo
                        span CODIGO
                    div.descripcion
                        span NOMBRE
                    div.accion
                        span Acciones
                div.item(v-for="(item, index) in cuentas" :key="index" )
                  div.cuerpo
                    div.titulo
                      v-icon(dark='' @click='showson(item)' v-if=('item.mostrando && item.child && item.child.length > 0')) zoom_out
                      v-icon(dark='' @click='showson(item)' v-if=('!item.mostrando && item.child && item.child.length > 0')) zoom_in
                      span(style='padding-left:5px;') {{item.codigocli}}
                    div.descripcion
                      | {{item.nombre}}
                    div.accion
                      a(@click='view(item)')
                        v-icon(dark='') remove_red_eye
                      a(@click='modalcrear(item)')
                        v-icon(dark='') add_circle_outline
                      a(@click='editItem(item)')
                        v-icon(dark='') edit
                      //- a(@click='deleteItem(item)')
                      //-   v-icon(dark='' v-if='!item.block || item.block === false || item.block === "false"') delete_outline
                  div.item(v-for="(item2, index2) in item.child" :key="index2" v-if=('item2.mostrar'))
                    div.cuerpo
                      div(style='padding-left:15px;').titulo
                        v-icon(dark='' @click='showson(item2)' v-if=('item2.mostrando && item2.child.length > 0')) zoom_out
                        v-icon(dark='' @click='showson(item2)' v-if=('!item2.mostrando && item2.child.length > 0')) zoom_in
                        div(style='width: 24px;'  v-if=('item2.child.length === 0'))
                        span(style='padding-left:5px;' ) {{item2.codigocli}}
                      div.descripcion
                        | {{item2.nombre}}
                      div.accion
                        a(@click='view(item2)')
                          v-icon(dark='') remove_red_eye
                        a(@click='modalcrear(item2)')
                          v-icon(dark='') add_circle_outline
                        a(@click='editItem(item2)')
                          v-icon(dark='') edit
                        //- a(@click='deleteItem(item2)')
                        //-   v-icon(dark='' v-if='!item.block || item.block === false || item.block === "false"') delete_outline
                    div.item(v-for="(item3, index3) in item2.child" :key="index3" v-if=('item3.mostrar'))
                      div.cuerpo
                        div(style='padding-left:25px;').titulo
                          v-icon(dark='' @click='showson(item3)' v-if=('item3.mostrando && item3.child.length > 0')) zoom_out
                          v-icon(dark='' @click='showson(item3)' v-if=('!item3.mostrando && item3.child.length > 0')) zoom_in
                          div(style='width: 24px;'  v-if=('item3.child.length === 0'))
                          span(style='padding-left:5px;')  {{item3.codigocli}}
                        div.descripcion
                          | {{item3.nombre}}
                        div.accion
                          a(@click='view(item3)')
                            v-icon(dark='') remove_red_eye
                          a(@click='modalcrear(item3)')
                            v-icon(dark='') add_circle_outline
                          a(@click='editItem(item3)')
                            v-icon(dark='') edit
                          //- a(@click='deleteItem(item3)')
                          //-   v-icon(dark='' v-if='!item.block || item.block === false || item.block === "false"') delete_outline
                      div.item(v-for="(item4, index4) in item3.child" :key="index4" v-if=('item4.mostrar'))
                        div.cuerpo
                          div(style='padding-left:35px;').titulo
                            v-icon(dark='' @click='showson(item4)' v-if=('item4.mostrando && item4.child.length > 0')) zoom_out
                            v-icon(dark='' @click='showson(item4)' v-if=('!item4.mostrando && item4.child.length > 0')) zoom_in
                            div(style='width: 24px;'  v-if=('item4.child.length === 0'))
                            span(style='padding-left:5px;') {{item4.codigocli}}
                          div.descripcion
                            | {{item4.nombre}}
                          div.accion
                            a(@click='view(item4)')
                              v-icon(dark='') remove_red_eye
                            a(@click='modalcrear(item4)')
                              v-icon(dark='') add_circle_outline
                            a(@click='editItem(item4)')
                              v-icon(dark='') edit
                            //- a(@click='deleteItem(item4)')
                            //-   v-icon(dark='' v-if='!item.block || item.block === false || item.block === "false"') delete_outline
                        div.item(v-for="(item5, index5) in item4.child" :key="index5" v-if=('item5.mostrar'))
                          div.cuerpo
                            div(style='padding-left:45px;').titulo
                              v-icon(dark='' @click='showson(item5)' v-if=('item5.mostrando && item5.child.length > 0')) zoom_out
                              v-icon(dark='' @click='showson(item5)' v-if=('!item5.mostrando && item5.child.length > 0')) zoom_in
                              div(style='width: 24px;'  v-if=('item5.child.length === 0'))
                              span(style='padding-left:5px;') {{item5.codigocli}}
                            div.descripcion
                              | {{item5.nombre}}
                            div.accion
                              a(@click='view(item5)')
                                v-icon(dark='') remove_red_eye
                              a(@click='modalcrear(item5)')
                                v-icon(dark='') add_circle_outline
                              a(@click='editItem(item5)')
                                v-icon(dark='') edit
                              //- a(@click='deleteItem(item5)')
                              //-   v-icon(dark='' v-if='!item.block || item.block === false || item.block === "false"') delete_outline
                          div.item(v-for="(item6, index6) in item5.child" :key="index6" v-if=('item6.mostrar'))
                            div.cuerpo
                              div(style='padding-left:55px;').titulo
                                v-icon(dark='' @click='showson(item6)' v-if=('item6.mostrando && item6.child.length > 0')) zoom_out
                                v-icon(dark='' @click='showson(item6)' v-if=('!item6.mostrando && item6.child.length > 0')) zoom_in
                                div(style='width: 24px;'  v-if=('item6.child.length === 0'))
                                span(style='padding-left:5px;') {{item6.codigocli}}
                              div.descripcion
                                | {{item6.nombre}}
                              div.accion
                                a(@click='view(item6)')
                                  v-icon(dark='') remove_red_eye
                                a(@click='modalcrear(item6)')
                                  v-icon(dark='') add_circle_outline
                                a(@click='editItem(item6)')
                                  v-icon(dark='') edit
                                //- a(@click='deleteItem(item6)')
                                //-   v-icon(dark='' v-if='!item.block || item.block === false || item.block === "false"') delete_outline
                            div.item(v-for="(item7, index7) in item6.child" :key="index7" v-if=('item7.mostrar'))
                              div.cuerpo
                                div(style='padding-left:65px;').titulo
                                  v-icon(dark='' @click='showson(item7)' v-if=('item7.mostrando && item7.child.length > 0')) zoom_out
                                  v-icon(dark='' @click='showson(item7)' v-if=('!item7.mostrando && item7.child.length > 0')) zoom_in
                                  div(style='width: 24px;'  v-if=('item7.child.length === 0'))
                                  span(style='padding-left:5px;') {{item7.codigocli}}
                                div.descripcion
                                  | {{item7.nombre}}
                                div.accion
                                  a(@click='view(item7)')
                                    v-icon(dark='') remove_red_eye
                                  a(@click='modalcrear(item7)')
                                    v-icon(dark='') add_circle_outline
                                  a(@click='editItem(item7)')
                                    v-icon(dark='') edit
                                  //- a(@click='deleteItem(item7)')
                                  //-   v-icon(dark='' v-if='!item.block || item.block === false || item.block === "false"') delete_outline
                              div.item(v-for="(item8, index8) in item7.child" :key="index8" v-if=('item8.mostrar'))
                                div.cuerpo
                                  div(style='padding-left:75px;').titulo
                                    v-icon(dark='' @click='showson(item8)' v-if=('item8.mostrando && item8.child.length > 0')) zoom_out
                                    v-icon(dark='' @click='showson(item8)' v-if=('!item8.mostrando && item8.child.length > 0')) zoom_in
                                    div(style='width: 24px;'  v-if=('item8.child.length === 0'))
                                    span(style='padding-left:5px;') {{item8.codigocli}}
                                  div.descripcion
                                    | {{item8.nombre}}
                                  div.accion
                                    a(@click='view(item8)')
                                      v-icon(dark='') remove_red_eye
                                    a(@click='modalcrear(item8)')
                                      v-icon(dark='') add_circle_outline
                                    a(@click='editItem(item8)')
                                      v-icon(dark='') edit
                                    //- a(@click='deleteItem(item8)')
                                    //-   v-icon(dark='' v-if='!item.block || item.block === false || item.block === "false"') delete_outline
                                div.item(v-for="(item9, index9) in item8.child" :key="index9" v-if=('item9.mostrar'))
                                  div.cuerpo
                                    div(style='padding-left:85px;').titulo
                                      v-icon(dark='' @click='showson(item9)' v-if=('item9.mostrando && item9.child.length > 0')) zoom_out
                                      v-icon(dark='' @click='showson(item9)' v-if=('!item9.mostrando && item9.child.length > 0')) zoom_in
                                      div(style='width: 24px;'  v-if=('item9.child.length === 0'))
                                      span(style='padding-left:5px;') {{item9.codigocli}}
                                    div.descripcion
                                      | {{item9.nombre}}
                                    div.accion
                                      a(@click='view(item9)')
                                        v-icon(dark='') remove_red_eye
                                      a(@click='modalcrear(item9)')
                                        v-icon(dark='') add_circle_outline
                                      a(@click='editItem(item9)')
                                        v-icon(dark='') edit
                                      //- a(@click='deleteItem(item9)')
                                      //-   v-icon(dark='' v-if='!item.block || item.block === false || item.block === "false"') delete_outline
                                  div.item(v-for="(item10, index10) in item9.child" :key="index10" v-if=('item10.mostrar'))
                                    div.cuerpo
                                      div(style='padding-left:95px;').titulo
                                        v-icon(dark='' @click='showson(item10)' v-if=('item10.mostrando && item10.child.length > 0')) zoom_out
                                        v-icon(dark='' @click='showson(item10)' v-if=('!item10.mostrando && item10.child.length > 0')) zoom_in
                                        div(style='width: 24px;'  v-if=('item10.child.length === 0'))
                                        span(style='padding-left:5px;') {{item10.codigocli}}
                                      div.descripcion
                                        | {{item10.nombre}}
                                      div.accion
                                        a(@click='view(item10)')
                                          v-icon(dark='') remove_red_eye
                                        a(@click='modalcrear(item10)')
                                          v-icon(dark='') add_circle_outline
                                        a(@click='editItem(item10)')
                                          v-icon(dark='') edit
                                        //- a(@click='deleteItem(item10)')
                                        //-   v-icon(dark='' v-if='!item.block || item.block === false || item.block === "false"') delete_outline
            v-dialog(v-model='dialog2', persistent='', max-width='40%')
                v-card(color='grey_1')
                    v-app-bar(dark color='primary')
                        span.headline Nueva cuenta contable
                    v-card-text
                        v-row(dense)
                            v-col(cols='12')
                               v-card(color='white')
                                  v-card-text
                                     v-row(dense)
                                        v-col(cols='12', sm='12', md='12')
                                            v-text-field#nombreCuenta(dense='', outlined='', v-model='editedItem.nombre', label='Nombre')
                                     v-row(dense)
                                        v-col(cols='12', sm='12', md='12')
                                            v-text-field#codigoCuenta(dense='', outlined='', v-model='editedItem.codigocli', label='Codigo')
                                        //- v-col(cols='12', sm='12', md='12')
                                        //-   v-text-field(dense='', outlined='', v-model='editedItem.descripcion', label='Descripcion')
                    v-card-actions
                        v-spacer
                        v-btn(color='error', small='', dark='', @click='close')
                            v-icon mdi-close
                            | Cancelar
                        v-btn(color='success', small='', dark='', @click='save')
                            v-icon mdi-content-save
                            | Guardar
            v-dialog(v-model='dialog3', persistent='', max-width='40%')
                v-card(color='grey_1')
                    v-app-bar(dark color='primary')
                        span.headline Cuenta contable
                    v-card-text
                        v-row(dense)
                           v-col(cols='12')
                              v-card(color='white')
                                 v-card-text
                                    v-row(dense)
                                       v-col(cols='12', sm='12', md='12')
                                           v-text-field#nombreCuenta(dense='', outlined='', reanonly, v-model='editedItem.nombre', label='Nombre')
                                    v-row(dense)
                                       v-col(cols='12', sm='12', md='12')
                                           v-text-field#codigoCuenta(dense='', outlined='', readonly, v-model='editedItem.codigocli', label='Codigo')
                                       //- v-col(cols='12', sm='12', md='12')
                                       //-     v-text-field(dense='', outlined='', v-model='editedItem.descripcion', label='Descripcion')
                    v-card-actions
                        v-spacer
                        v-btn(color='error', small='', dark='', @click='close')
                            v-icon mdi-close
                            | Salir
</template>

<script>
import Api from '@/services/methods'

export default {
  data: () => ({
    dialog: false,
    cuentas: [],
    cuentasres: [],
    search: '',
    permisosRuta: {},
    dialog2: false,
    dialog3: false,
    editedIndex: -1,
    editedItem: {
      nombre: '',
      referencia: '',
      codigo: '',
      codigocli: '',
      saldo: 0,
      saldoInicial: 0,
      debe: 0,
      haber: 0,
      block: false
    },
    defaultItem: {
      nombre: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nueva Cuenta'
        : 'Modificar Cuenta'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    dialog2 (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    prueba (data) {
      return data + 'px'
    },
    modalcrear (item) {
      this.editedItem.referencia = item.codigo
      this.dialog2 = true
    },
    showson (data) {
      for (let j = 0; j < data.child.length; j++) {
        data.child[j].child = []
      }
      for (let i = 0; i < this.cuentasres.length; i++) {
        for (let j = 0; j < data.child.length; j++) {
          if (data.child[j].codigo === this.cuentasres[i].referencia) {
            data.child[j].child.push(this.cuentasres[i])
          }
        }
      }
      data.mostrando = !data.mostrando
      if (data.child) {
        data.child.map(element => {
          element.mostrar = !element.mostrar
        })
      }
    },
    initialize () {
      this.listarMarcas()
      /* this.permisosRuta = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta == 'cuentas') */
    },
    recorrer () {
    },
    validarCrear () {
      /* return this.permisosRuta.accion.includes('Crear') */
      return true
    },

    validarModificar () {
      /* return this.permisosRuta.accion.includes('Modificar') */
      return true
    },

    validarEliminar () {
      /* return this.permisosRuta.accion.includes('Eliminar') */
      return true
    },

    listarMarcas () {
      Api.get('cuentas')
        .then(response => {
          this.cuentas = []
          for (let i = 0; i < response.data.length; i++) {
            response.data[i].mostrar = false
            response.data[i].mostrando = false
            if (response.data[i].codigo === response.data[i].referencia) {
              this.cuentas.push(response.data[i])
            }
          }
          let data = response.data
          this.cuentasres = response.data
          for (let i = 0; i < data.length; i++) {
            if (data[i].codigo !== data[i].referencia) {
              for (let j = 0; j < this.cuentas.length; j++) {
                if (data[i].referencia === this.cuentas[j].codigo) {
                  if (this.cuentas[j].child) {
                    this.cuentas[j].child.push(data[i])
                  } else {
                    this.cuentas[j].child = []
                    this.cuentas[j].child.push(data[i])
                  }
                }
              }
            }
          }
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
             // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },

    view (item) {
      this.editedItem = Object.assign({}, item)
      this.dialog3 = true
    },

    editItem (item) {
      this.editedIndex = 0
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quiere borrar?',
        text: 'No podrá revertir',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          Api.put('/cuentas/deletelog/' + item._id).then(response => {
            this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
            this.listarMarcas()
          })
        }
      })
    },

    close () {
      this.dialog = false
      this.dialog2 = false
      this.dialog3 = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    validarCampos () {
      if (this.editedItem.nombre === '') {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene el campo para continuar'
        })
        return true
      } else {
        if (this.editedItem.nombre.length > 20) {
          this.$swal({
            icon: 'error',
            title: 'Error!',
            text: 'Ha excedido el limite de caracteres'
          })
          return true
        }
      }
      return false
    },

    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    },
    create () {

    },
    save () {
      if (!this.validarCampos()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        if (this.editedIndex > -1) {
          Api.put('cuentas', this.editedItem)
            .then(response => {
              this.$swal({
                icon: 'success',
                title: 'Modificacion exitosa',
                text: 'Todos los cambios han sido efectuados'
              })
            })
            .catch(e => {
              this.$swal({
                icon: 'error',
                title: 'Error al modificar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            })
          this.listarMarcas()
          this.close()
        } else {
          Api.post('cuentas', this.editedItem)
            .then(response => {
              if (response.data.erro) {
                this.$swal({
                  icon: 'error',
                  title: 'Error al guardar',
                  text: response.data.erro
                })
              } else {
                this.$swal({
                  icon: 'success',
                  title: 'Inclusion exitosa',
                  text: 'Todos los datos han sido guardados'
                })
                this.listarMarcas()
                this.close()
              }
            })
            .catch(e => {
              console.log('error' + e)
              this.$swal({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            })
        }
      }
    }
  }
}
</script>
<style lang='scss'>
@import '~@/assets/scss/cuentas.scss';
</style>
